<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-right">
                  <button @click="voltarPagina" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </button>
                  <span class="badge badge-warning mr-1" v-show="!pedido.data_inicio &&
                    !pedido.suplementar &&
                    !pedido.rapido
                    ">Pedido SOS</span>
                  <span class="badge badge-secondary mr-1" v-show="pedido.suplementar">Pedido Suplementar</span>
                  <span class="badge badge-info mr-1" v-show="pedido.rapido">Pedido Rápido</span>
                  <span class="badge" :class="'badge-' + pedido.status_class">
                    {{ pedido.status_f }}
                  </span>
                </div>
                <div class="col-md-6" v-show="pedido.data_inicio">
                  <label>Data inicial</label>
                  <input type="date" class="form-control" v-model="pedido.data_inicio" disabled />
                </div>
                <div class="col-md-6" v-show="pedido.data_fim">
                  <label>Data final</label>
                  <input type="date" class="form-control" v-model="pedido.data_fim" disabled />
                </div>
                <div class="col-md-6">
                  <label>Unidade solicitante</label>
                  <input type="text" class="form-control" :value="pedido.u_solicitante ? pedido.u_solicitante.nome : ''
                    " disabled />
                </div>
                <div class="col-md-6">
                  <label>Unidade solicitada</label>
                  <input type="text" class="form-control" :value="pedido.u_solicitada ? pedido.u_solicitada.nome : ''"
                    disabled />
                </div>
                <div class="col-md-12">
                  <label>Observações</label>
                  <div class="row px-1">
                    <div class="col-md-12 p-1" style="border: 1px solid #ccc; border-radius: 8px"
                      v-for="observacao in observacoes" :key="observacao.id">
                      <b>{{
                        (observacao.user_id
                          ? observacao.user.name
                          : "Não informado") +
                        " (" +
                        observacao.created_at_f +
                        ")"
                      }}</b>
                      <div v-html="observacao.texto"></div>
                    </div>
                  </div>
                </div>
                <div class="col-md-8 mt-1">Material</div>
                <div class="col-md-2 mt-1">Solicitado</div>
                <div class="col-md-2 mt-1">Atendido</div>
                <div class="col-md-12 row p-0 m-0" id="lotes" v-for="(material_pedido, id) in pedido_material"
                  :key="id">
                  <div class="col-md-8 mt-1">
                    <span v-if="material_pedido.material">
                      {{ material_pedido.material.nome }}
                    </span>
                    <span v-else class="text-muted font-italic">
                      Material removido do sistema
                    </span>
                  </div>
                  <div class="col-md-2 mt-1">
                    {{ material_pedido.quantidade_solicitada }}
                  </div>
                  <div class="col-md-2 mt-1" v-if="pedido.status === 0">
                    Pedido solicitado
                  </div>
                  <div class="col-md-2 mt-1" v-if="[1, 6].includes(pedido.status)">
                    Pedido não atendido
                  </div>
                  <div class="col-md-2 mt-1" v-if="[2, 3, 4, 5, 7, 8, 9].includes(pedido.status)">
                    {{ material_pedido.quantidade_atendida }}
                  </div>
                </div>
                <div class="col-12 mt-1 row" v-if="pedido.recebido">
                  <div class="col-12 d-flex justify-content-center">
                    <img :src="pedido.assinatura" alt="Assinatura" />
                  </div>
                  <div class="col-12 d-flex justify-content-center">
                    {{
                      pedido.recebido == 1 || pedido.recebido == 3
                        ? "Recebido"
                        : "Rejeitado"
                    }}
                    por {{ pedido.recebido_por }} às {{ pedido.recebido_em_f }}
                  </div>
                </div>
              </div>
              <div class="row" v-if="pedido.recebido">
                <div class="col-12 my-1">
                  <MapComponent :latitude="pedido.latitude" :longitude="pedido.longitude" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import MapComponent from "../../components/MapComponent.vue";

export default {
  name: "imageUpload",
  data() {
    return {
      pedido_material: [],
      pedido: {},
      unidades: [],
      observacoes: {},
    };
  },
  computed: {},
  methods: {
    voltarPagina() {
      this.$router.go(-1);
    },

    getPedidos: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "pedidos/" +
        id +
        "?with[]=u_solicitante&with[]=u_solicitada";

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.pedido = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getMaterialPedidos: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        `material_pedidos?paginated=false&pedido_id=${id}&with[]=material`;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.pedido_material = response.data.data;
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getObservacoes: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "observacoes?with[]=user&ppaginated=false&pedido_id=" +
        id;

      axios
        .get(api)
        .then((response) => {
          self.observacoes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?aginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getUnidades();

    if (id) {
      self.getPedidos(id);
      self.getObservacoes(id);
      self.getMaterialPedidos(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    MapComponent,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

.badge-orange {
  background: #d34300;
  color: white;
}

.badge-purple {
  background: #880088;
  color: white;
}
</style>